<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="24">
            <el-col :span="7">
              <el-form-item label="Facility" prop="supplierCode">
                <el-input class="handle-input" v-model="queryCondition.supplier" clearable></el-input>
                <el-input v-model.trim="queryCondition.type" v-show="false"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="7">
                            <el-form-item :label="$t('base.plant.plantName')" prop="supplierName">
                                <el-input class="handle-input" v-model.trim="queryCondition.supplierName" clearable></el-input>
                            </el-form-item>
                        </el-col> -->

          </el-row>
          <el-row type="flex" justify="center">
            <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
        <el-button v-if="multipleSelectionFlag" type="primary" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table" ref="supplierSelectTabel" @selection-change="handleSelectionChange" :row-key="(row)=>{return row.tmSupplierId+row.categoryLevel1Name+row.categoryLevel2Code+row.categoryLevel3Code}">
        <el-table-column v-if="multipleSelectionFlag" :prop="tmSupplierId" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column show-overflow-tooltip v-else fixed width="55" :label="$t('common.select')" sortable prop="tmSupplierId">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.tmSupplierId+scope.row.categoryLevel1Code+scope.row.categoryLevel2Code+scope.row.categoryLevel3Code">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('visitPlan.FactoryNo')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('visitPlan.FactoryName')"></el-table-column>
        <template v-if="queryCondition.categoryLevel1Name=='Food'">
          <el-table-column show-overflow-tooltip prop="parentSupplierCode" :label="$t('visitPlan.SupplierNo')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="parentSupplierName" :label="$t('visitPlan.SupplierName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="dcCategory.categoryLevel1Name" label="Category level1 Name" min-width='130'></el-table-column>
          <el-table-column show-overflow-tooltip prop="dcCategory.categoryLevel2Name" label="Category level2 Name" min-width="130"></el-table-column>
        </template>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { search } from "@/api/base-data/supplier";
import { visitPlanDetailAddSeach } from "@/api/visitPlan.js";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils"
import commonFun from "@/utils/commonFun";
export default {
  name: 'carriers-sel-page',
  data() {
    return {
      Categorylevel: true,
      tableData: [],
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        categoryLevel1Name: "",
        supplier: '',
      },
      radioVal: null,
      selectRows: null,
      multipleSelection: [],
      supplierStatusList: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
    }
  },
  props: {
    supplierInfoOnly: Boolean,
    multipleSelectionFlag: Boolean,
    categoryLevel1Name: String,
    categoryLevel2Name: String,
  },
  created() {
    if (commonFun.havePermission('IS_HGS')) {
      this.queryCondition.categoryLevel1Name = "Package";
    } else {
      this.queryCondition.categoryLevel1Name = this.categoryLevel1Name
    }
    this.queryCondition.categoryLevel2Name = this.categoryLevel2Name
    this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    //查询承运商
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      this.queryCondition.supplierInfoOnly = this.supplierInfoOnly ? 'Y' : 'N';
      visitPlanDetailAddSeach(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    toggleSelection() {
      this.$refs.supplierSelectTabel.clearSelection();
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRows = [];
      this.selectRows = row;
    },
    clickSelectMethod: function () {
      let that = this;
      if (this.selectRows == null) {
        that.$message({
          message: this.$t("common.pleaseSelectOneData"),
          type: "warning"
        });
      } else {
        this.$emit('subCallMethod', this.selectRows);
      }
    },
    //获取下拉列表数据
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.supplierStatusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    },
    handleSelectionChange(rows) {
      let that = this
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          that.selectRows.push(row);
        });
      }
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryCondition.supplier = '';

    },
  },
  extends: commonFunction
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
</style>
